export default "__VITE_ASSET__wQOe34pW__"